import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
   
  //private baseUrl: string = 'https://localhost:7033/api';
  private baseUrl: string = 'https://pdfconverterapi.thepdfleader.com/api';

  setApiUrl(url: string): void {
    this.baseUrl = url;
  }

  getApiUrl(): string {
    return this.baseUrl;
  }
}
